<template>
  <div class="contacts">
    <div class="contacts__top">
      <div class="content">
        <div class="contacts__top-container">
          <div class="contacts__text">
            <div class="contacts__title">Контакты</div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumbs :pages="[{ name: 'Контакты' }]" />
    <div class="content">
      <div class="contacts__row">
        <div class="contacts__body">
          <div class="contacts__body-info">
            <div class="contacts__list-title">
              По общим вопросам деятельности компании обращайтесь в офис
              компании «АстраЗенека Россия» по адресу:
            </div>
            <ul class="contacts__list">
              <li class="contacts__list-item subtitle">Офис в Москве:</li>
              <li class="contacts__list-item">
                123112, г. Москва, 1-й Красногвардейский проезд, д.21, стр.1.,
                30 этаж
              </li>
              <li class="contacts__list-item">Бизнес-центр «ОКО»</li>
              <li class="contacts__list-item">
                Телефон: <a href="tel:84957995699">+7 (495) 799-56-99</a>
              </li>
              <li class="contacts__list-item">
                Email:
                <a href="mailto:Moscow.reception@astrazeneca.com"
                  >Moscow.reception@astrazeneca.com</a
                >
              </li>
            </ul>
            <ul class="contacts__list">
              <li class="contacts__list-item subtitle">Производство:</li>
              <li class="contacts__list-item">
                49020, Калужская область, Боровский район, деревня Добрино, 1-ый
                Восточный проезд, владение 8
              </li>
              <li class="contacts__list-item">
                Телефон: <a href="tel:84843826100">+7 (48438) 2-61-00</a>
              </li>
              <li class="contacts__list-item">
                Факс: <a href="tel:84843826109">+7 (48438) 2-61-09</a>
              </li>
              <li class="contacts__list-item">
                Email:
                <a href="mailto:Vorsino.reception@astrazeneca.com"
                  >Vorsino.reception@astrazeneca.com</a
                >
              </li>
            </ul>
          </div>

          <InfoDrop v-for="(item, ind) in blocks" :key="ind" :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "../components/pageComponents/Breadcrumbs.vue";
import InfoDrop from "../components/pageComponents/InfoDrop.vue";
export default {
  metaInfo: {
    title: "Контакты",
  },
  name: "ContactUs",
  components: {
    Breadcrumbs,
    InfoDrop,
  },
  data: () => ({
    blocks: [
      {
        title: "Служба Медицинской Информации",

        content:
          '<div class="contacts__drop"><p>Если вас интересует медицинская и научная информация о препаратах компании, вы можете отправить запрос на её получение с помощью веб-формы по передаче запросов <a href="https://contactazmedical.astrazeneca.com/content/astrazeneca-champion/ru/ru/amp-form.html" class="contacts__link-underline">CHAMPion</a>, или по электронной почте <a href="mailto:Medinfo.ru@astrazeneca.com">Medinfo.ru@astrazeneca.com</a> или по телефону <a href="tel:84957995699">+7 (495) 799-56-99</a>.</p> <p>Обращаем ваше внимание на следующие положения по обработке персональных данных в связи с Вашим сообщением:</p><ul class="contacts__drop drop-list"><li class="contacts__drop drop-item">Указывая в сообщении ваши персональные данные, вы даёте согласие на их обработку компанией «АстраЗенека» с целью предоставления ответа на запрос по медицинской информации.</li><li class="contacts__drop drop-item">Обработка персональных данных включает запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), использование, обезличивание, уничтожение. Предоставленные персональные данные будут уничтожены из информационных систем компании «АстраЗенека» по достижении цели их обработки.</li><li class="contacts__drop drop-item">В случае вашего несогласия с обработкой персональных данных компанией «АстраЗенека», пожалуйста, отправьте электронное сообщение на адрес <a href="mailto:Medinfo.ru@astrazeneca.com">Medinfo.ru@astrazeneca.com</a> с комментарием «Не согласен». С момента получения вашего сообщения, компания «АстраЗенека» прекратит обработку ваших персональных данных и вашего запроса.</li></ul></div>',
      },
      {
        title: "Качество/подлинность лекарственных препаратов",

        content:
          '<div class="contacts__drop"><p>Если вы хотите сообщить о претензии в отношении качества или подлинности лекарственного препарата компании «АстраЗенека», пожалуйста, обратитесь  в Группу по обеспечению качества лекарственных препаратов ООО «АстраЗенека Фармасьютикалз»:</p><p>по электронной почте: <a href="mailto:ProductQuality.ru@astrazeneca.com">ProductQuality.ru@astrazeneca.com</a>, <br>по телефону: <a href="tel:84957995699*5">+7 (495) 799-56-99*5</a></p></div>',
      },
      {
        title: "Коммерческая деятельность",

        content:
          '<div class="contacts__drop"><p>По вопросам коммерческой деятельности и развития партнёрства с компанией «АстраЗенека» обращайтесь по адресу:</p><p> <a href="mailto:Commercial.Russia@astrazeneca.com">Commercial.Russia@astrazeneca.com</a>, а также по телефону <a href="tel:84957995699">+7 (495) 799-56-99</a></p></div>',
      },
      {
        title: "Работа в Компании",

        content:
          '<div class="contacts__drop"><p>Если вы заинтересованы в работе в нашей компании, направляйте своё резюме по адресу: <a href="mailto:Job.Russia@astrazeneca.com">Job.Russia@astrazeneca.com</a>, а также по телефону <a href="tel:84957995699">+7 (495) 799-56-99</a></p><p>Если вы заинтересованы в работе на производстве, направляйте своё резюме по адресу: <a href="mailto:Job.production-russia@astrazeneca.com">Job.production-russia@astrazeneca.com</a></p></div>',
      },
      {
        title: "Работа со СМИ",

        content:
          '<div class="contacts__drop"><p>По вопросам работы со СМИ направляйте по адресу: <a href="mailto:PR.Russia@astrazeneca.com">PR.Russia@astrazeneca.com</a></p><ul class="contacts__drop drop-list"><li class="contacts__drop"><a class="contacts__link-underline" href="https://astrazeneca.ru/">Список полезных ссылок</a></li><li class="contacts__drop drop-item"><a class="contacts__link-underline" href="https://www.astrazeneca.com/our-company/contact-us.html">Адреса офисов компании по всему миру</a></li></ul><p>Мы постараемся рассмотреть ваше сообщение в самое ближайшее время. Благодарим вас за проявление интереса к нашей компании.</p><p>Пожалуйста, обратите внимание, что направляя обращение в компанию, вы автоматически даёте согласие на обработку персональных данных компанией «АстраЗенека».</p><p>Информация о конфиденциальности: «АстраЗенека» заботится о конфиденциальности отправленных сообщений. Ваш электронный адрес будет использован исключительно для ответа на вопрос.</p></div>',
      },
    ],
  }),
  methods: {
    pageVisit(time) {
      this.$axios(`/api/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: "",
          brand_id: "",
          content_date: "",
          content_id: "",
          content_name: "Контакты",
          content_type: "Контакты",
          nosology_name: "",
          content_parameter: "",
          event_type: "visit",
          event_duration: time,
          url: this.$root.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: "Контакты",
          page_type: "Контакты",
          nova_id: this.$root.analyticData.nova_id,
          session_id: this.$root.analyticData.session_id,
          user_id: this.$root.analyticData.user_id,
          browser: this.$root.analyticData.browser,
          device_type: this.$root.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.$root.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    },
  },
  mounted() {
    this.pageVisit(0);
    setTimeout(() => {
      this.pageVisit(5);
    }, 5000);
    setTimeout(() => {
      this.pageVisit(30);
    }, 30000);
  },
};
</script>

<style lang="scss" scoped>
.contacts {
  &__link-underline {
    text-decoration: underline;
  }
  &__title {
    margin-top: 32px;
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #1f1f1f;
  }
  &__list-title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 23px;
    line-height: 29px;
    color: #1f1f1f;
  }
  &__list {
    margin-top: 24px;
    &-item {
      margin-bottom: 16px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #3c4242;
      a {
        color: #d0006f;
      }
      &.subtitle {
        font-weight: 500;
        margin-bottom: 8px;
      }
    }
  }
  &__row {
    margin-top: 64px;
    display: grid;
    grid-template-columns: 1fr 280px;
    column-gap: 136px;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
      row-gap: 40px;
    }
  }
  .info-item.active {
    border-bottom: 1px solid rgba(66, 71, 83, 0.3);
  }
}
</style>

<style lang="scss">
.contacts {
  &__drop {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #3c4242;
    p {
      margin-bottom: 16px;
    }
    a {
      display: inline-block;
      color: #d0006f;
    }
    &.drop-list {
      list-style: disc;
      padding-left: 16px;
    }
    &.drop-item {
      margin-bottom: 16px;
    }
  }
}
</style>